import useSWR from 'swr';

import axios, { endpoints } from 'src/lib/axios';

// Nº de "huecos de conocimiento" (preguntas con voto negativo agrupadas), para el badge del menú.
export function useAgentKbGapCount() {
  const { data, mutate } = useSWR(
    endpoints.agentKbGap.count,
    async (url: string) => {
      const res = await axios.get(url);
      return (res.data?.count as number) ?? 0;
    },
    { revalidateOnFocus: false, refreshInterval: 120000 }
  );

  return { count: data ?? 0, refresh: mutate };
}
